export default __webpack_public_path__ + "static/media/bannerImage1.a11bacbc.jpg";